<script setup>
import { defineAsyncComponent } from 'vue'

// Panel (list + virtual scroller) only loads once the popover opens.
const NotificationsPanel = defineAsyncComponent(() => import('./NotificationsPanel.vue'))

// Notifications panel behind any trigger: pass the trigger element as the default slot.
// The slot receives `open` so the trigger can render an active state while the panel is showing.
const { resourceId, title, side, width, view } = defineProps({
    resourceId: {
        type: String,
        default: null,
    },
    title: {
        type: String,
        default: 'Notifications',
    },
    side: {
        type: String,
        default: 'bottom',
    },
    sideOffset: {
        type: Number,
        default: 3,
    },
    width: {
        type: String,
        default: 'w-96',
    },
    // Pane the panel opens on: 'list' or 'settings'.
    view: {
        type: String,
        default: 'list',
    },
})

const emit = defineEmits(['openChange'])

const isOpen = defineModel('open', { type: Boolean, default: false })

function onOpenChange(open) {
    isOpen.value = open
    emit('openChange', open)
}
</script>

<template>
    <PopOver v-model:open="isOpen" :side="side" label="Notifications" @open-change="onOpenChange">
        <template #trigger>
            <slot :open="isOpen" />
        </template>
        <template #content="{ close }">
            <PopOverContentDefault
                :side="side"
                :side-offset="sideOffset"
                class="overflow-hidden p-0"
                arrow-fill-color="fill-slate-50"
            >
                <PopOverPanel :width="width">
                    <NotificationsPanel :resource-id="resourceId" :title="title" :view="view" @close="close()" />
                </PopOverPanel>
            </PopOverContentDefault>
        </template>
    </PopOver>
</template>
